/** @jsxImportSource @emotion/react */
import Table from 'components/Table'
import { PlatformSlug } from 'constants/consts'
import { CancellationUser } from '../types'
import { getDurationLabel, getFullName, getMembershipTypeLabel, getMessage, getReasonLabel } from '../utils'
import * as classes from '../styles'

type Props = {
  platformSlug?: PlatformSlug
  users: CancellationUser[]
  loading: boolean
}

export const CancelledUsersTable = ({ platformSlug, users, loading }: Props) => (
  <Table
    css={classes.tableWrapper}
    columns={[
      {
        title: 'Name',
        renderCell: ({ firstName, lastName }) => getFullName(firstName, lastName),
        flex: 1.2,
      },
      {
        title: 'Email',
        renderCell: ({ email }) => email,
        flex: 1.4,
      },
      {
        title: 'Membership Type',
        renderCell: ({ membershipType }) => getMembershipTypeLabel(membershipType),
        flex: 1.2,
      },
      {
        title: 'Duration',
        renderCell: ({ duration }) => getDurationLabel(duration),
        flex: 0.9,
      },
      {
        title: 'Reason',
        renderCell: ({ cancellationReason }) => getReasonLabel(cancellationReason, platformSlug),
        flex: 1.3,
      },
      {
        title: 'Message',
        renderCell: ({ cancellationReason, cancellationReasonDescription }) =>
          getMessage({ cancellationReasonDescription, cancellationReason, platformSlug }),
        flex: 1.6,
      },
    ]}
    items={users}
    isNotLoaded={loading}
    wrapperMinWidth={860}
  />
)
